import { IconSVG } from '../types';

export const WaterBottle = ({ size, style }: IconSVG) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 25 25"
      style={style}
    >
      <path
        fill="currentColor"
        d="M15.369 11.347h-5.35c-.084.2-.184.396-.3.587a1.847 1.847 0 01-.425.488l.725 7.925h5.35l.725-7.925a2.414 2.414 0 01-.425-.5 3.762 3.762 0 01-.3-.575zm-5.625-4l-.275 1.1a3.096 3.096 0 01.55.9h5.35a3.159 3.159 0 01.55-.9l-.275-1.1h-5.9zm.275 15c-.517 0-.967-.17-1.35-.513-.384-.341-.6-.77-.65-1.287l-.775-8.65a.798.798 0 01.425-.8c.133-.083.25-.183.35-.3a.63.63 0 00.15-.425.827.827 0 00-.4-.725.807.807 0 01-.375-.388.752.752 0 01-.05-.537l.65-2.625a.884.884 0 01.35-.55c.183-.133.391-.2.625-.2h2.725v-1h-1.5v-2h5v2h-1.5v1h2.725c.233 0 .437.067.612.2a.903.903 0 01.338.55l.675 2.625a.753.753 0 01-.05.537.807.807 0 01-.375.388.774.774 0 00-.313.275.723.723 0 00-.112.4.76.76 0 00.137.462c.092.125.213.23.363.313a.91.91 0 01.35.337.744.744 0 01.1.463l-.775 8.625a1.96 1.96 0 01-.65 1.3c-.384.35-.834.525-1.35.525h-5.35z"
      />
    </svg>
  );
};
